import date, {validateKapitelDate} from "@/helper/datetime/date";
import {kapitelDateString, kapitelMonthString, kapitelYearString} from "@/graphql/kapitelTypes";

export const getCurrentKapitelMonth = (): kapitelMonthString => {
    return getKapitelMonthFromKapitelDate(date.getToday())
}

export const isCurrentKapitelMonth = (dateString: kapitelMonthString | kapitelDateString): boolean => {
    return getCurrentKapitelMonth() === dateString
}

export const getKapitelMonthFromKapitelDate = (dateString: kapitelDateString): kapitelMonthString => {
    return date.formatKapitelDate(dateString, "yyyy-MM-01") as kapitelMonthString
}

export const add = (monthString: kapitelMonthString, amount: number): kapitelMonthString => date.addMonths(monthString, amount) as kapitelMonthString
export const sub = (monthString: kapitelMonthString, amount: number): kapitelMonthString => date.subMonths(monthString, amount) as kapitelMonthString
export const min = (...dates: kapitelMonthString[]): kapitelMonthString => date.min(...dates) as kapitelMonthString
export const max = (...dates: kapitelMonthString[]): kapitelMonthString => date.max(...dates) as kapitelMonthString
export const isAfter = (monthString1: kapitelMonthString, monthString2: kapitelMonthString) => date.isAfter(monthString1, monthString2)
export const isBefore = (monthString1: kapitelMonthString, monthString2: kapitelMonthString) => date.isBefore(monthString1, monthString2)
export const isBetween = (monthString: kapitelMonthString, min: kapitelMonthString, max: kapitelMonthString) => date.isBetween(monthString, min, max)

export const getKapitelYearStringFromKapitelMonthString = (month: kapitelMonthString): kapitelYearString => {
    return date.formatKapitelDate(month, "yyyy-01-01") as kapitelYearString
}

export const firstMonthOfYear = (year: kapitelYearString): kapitelMonthString => {
    return getKapitelMonthFromKapitelDate(year)
}
export const lastMonthOfYear = (year: kapitelYearString): kapitelMonthString => {
    return add(firstMonthOfYear(year), 11)
}

export const formatKapitelMonth = (month: kapitelMonthString, format = 'LLLL') => {
    return date.formatKapitelDate(month, format)
}
export const formatKapitelMonthYear = (month: kapitelMonthString, format = 'LLLL y') => {
    return date.formatKapitelDate(month, format)
}
export const formatKapitelYear = (year: kapitelYearString, format = 'y') => {
    return date.formatKapitelDate(year, format)
}

export const cmpKapitelMonth = (string1: kapitelMonthString, string2: kapitelMonthString) => date.cmpKapitelDate(string1, string2)

export default {
    getKapitelMonthFromKapitelDate,
    isCurrentKapitelMonth,
    getCurrentKapitelMonth,
    add,
    sub,
    min,
    max,
    isAfter,
    isBefore,
    isBetween,
    getKapitelYearStringFromKapitelMonthString,
    firstMonthOfYear,
    lastMonthOfYear,
    formatKapitelMonth,
    formatKapitelMonthYear,
    formatKapitelYear,
    cmpKapitelMonth
}
